<template>
  <div class="performer-project">
    <performer-project-title :title="model.name" :status="model.status" />
    <project-info
      class="performer-project__info"
      :type="model.type"
      :number="model.number"
      :requestId="model.requestId"
      :status="model.status.text"
    />

    <slot name="underInfo"></slot>

    <horizontal-filter>
      <filter-item
        :path="`/performer/project/${model?.id}/form`"
        :hash="getFormStepHash(model.id)"
        text="Карточка проекта"
      />
      <filter-item
        v-if="model.showAllTasks"
        :path="`/performer/project/${model.id}/tasks`"
        hash="#all"
        text="Все задачи"
      />
      <filter-item
        :path="`/performer/project/${model.id}/tasks`"
        hash="#my"
        text="Мои задачи"
      />
    </horizontal-filter>

    <div class="performer-project__content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
  import { useRoute } from 'vue-router';
  import ProjectInfo from '../components/ProjectInfo.vue';
  import HorizontalFilter from '@/components/filter/horizontal/HorizontalFilter.vue';
  import FilterItem from '@/components/filter/components/FilterItem.vue';
  import PerformerProjectTitle from '@/views/performer/components/PerformerProjectTitle.vue';

  const route = useRoute();

  defineProps({
    model: {
      type: Object,
      require: true,
    },
  });

  const getFormStepHash = (id) => {
    if (route.path !== '/performer/project/' + id + '/form') {
      return '#1';
    }
    return route.hash;
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  .performer-project {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 100px;

    .performer-project__info {
      align-items: center;
      margin-top: 10px;
      margin-bottom: 20px;
    }

    .performer-project__content {
      padding: 30px 0;
    }
  }
</style>
